<!--
 * @Author: tony.zhu
 * @Date: 2025-08-20 11:56:45
 * @LastEditTime: 2025-11-04 09:40:24
 * @LastEditors: tony.zhu
 * @Description: 
-->

<template>
  <el-dropdown-menu
    :class="[
      'c-template_dropdown_menu', $attrs.className !== undefined ? $attrs.className : '',
    ]"
  >
    <el-dropdown-item
      v-for="(item, index) in list"
      :key="index"
      :disabled="item.disabled != undefined ? item.disabled : false"
      :divided="item.divided != undefined ? item.divided : false"
      :class="[
        'c-template_dropdown_menu__item',
        item.code == 'del' ? 'is-del' : '',
      ]"
      @click.native="
        () => {
          $emit('on-click', { item, index });
        }
      "
    >
      <div v-if="item.custom">
        <slot name="custom" :data="item"></slot>
      </div>
      <div v-else class="value">
        <i :class="[item.icon, 'icon']" v-if="item.icon"></i> {{ item.value }}
      </div>
    </el-dropdown-item>
  </el-dropdown-menu>
</template>

<script>
export default {
  name: "El-dropdown-menu",
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
  },
 };
</script>

<style lang="scss" scoped>
.c-template_dropdown_menu {
  background: #ffffff;
  box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  margin-top: 0;
  min-width: 52px;
  padding: 8px 0;
  .c-template_dropdown_menu__item {
    font-size: 13px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #1d2129;
    line-height: 20px;
    padding: 0;
    .value {
      padding: 8px 20px;
      white-space: nowrap;
    }
    .icon {
      font-size: 16px;
      margin-right: 4px;
      color: #86909c;
    }
    &.is-disabled {
      color: #bbb;
      pointer-events: none;
    }

    &.is-del {
      &:hover {
        ::v-deep &.el-dropdown-menu__item {
          &:not(.is-disabled) {
            background-color: rgba(245, 63, 63, 0.1) !important;
          }
          .value {
            color: #f53f3f;
          }
        }
      }
    }
  }
  ::v-deep .el-dropdown-menu__item:focus {
    background: rgba(76, 188, 154, 0.2);
    color: #4cbc9a;
  }
  ::v-deep.el-dropdown-menu__item:not(.is-disabled):hover {
    background: rgba(76, 188, 154, 0.2);
    color: #4cbc9a;
  }
  ::v-deep .popper__arrow {
    display: none;
  }
}

.menu_dropdown_class {
  box-shadow: 0px 2px 10px 0px rgba(78, 89, 105, 0.1),
    0px 2px 14px 0px rgba(78, 89, 105, 0.21);
  border-radius: 0;
  padding: 4px 0;
  .c-template_dropdown_menu__item {
    min-width: 73px;
    .value {
      padding: 0;
    }

    ::v-deep {
      &.el-dropdown-menu__item {
        padding: 7px 18px;
        min-width: 82px;
      }
      &.el-dropdown-menu__item:focus {
        background: rgba(242, 243, 245, 1);
        color: #1d2129;
      }
      &.el-dropdown-menu__item:not(.is-disabled):hover {
        background: rgba(242, 243, 245, 1);
        color: #1d2129;
      }
    }
  }
}
</style>